"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FontSize = void 0;
var FontSize;
(function (FontSize) {
    FontSize["Zero"] = "u-font-zero";
    FontSize["Base"] = "u-font-base";
    FontSize["XSmall"] = "u-font-xs";
    FontSize["XSmallImportant"] = "u-font-xs!";
    FontSize["XSmallAtMedium"] = "u-font-xs@m";
    FontSize["Small"] = "u-font-small";
    FontSize["SmallImportant"] = "u-font-small!";
    FontSize["SmallAtMedium"] = "u-font-small@m";
    FontSize["Medium"] = "u-font-medium";
    FontSize["MediumImportant"] = "u-font-medium!";
    FontSize["MediumAtMedium"] = "u-font-medium@m";
    FontSize["Large"] = "u-font-large";
    FontSize["LargeImportant"] = "u-font-large!";
    FontSize["LargeAtMedium"] = "u-font-large@m";
    FontSize["XLarge"] = "u-font-xl";
    FontSize["XLargeImportant"] = "u-font-xl!";
    FontSize["XLargeAtMedium"] = "u-font-xl@m";
    FontSize["XXLarge"] = "u-font-xxl";
    FontSize["XXLargeImportant"] = "u-font-xxl!";
    FontSize["XXLargeAtMedium"] = "u-font-xxl@m";
})(FontSize = exports.FontSize || (exports.FontSize = {}));
//# sourceMappingURL=FontSize.js.map